var $product_img_cell = $(".variant_imgs_cell"), 
    $product_img_cell_array = [],
    $product_slider = $("#productImg").flickity(); 
	$product_slider.flickity("destroy"), 
    $(function () { 
        productImgArray(), imageUpdater();
    }),
    (productImgArray = () => {
        $product_img_cell.each(function () {
            var r = $(this);
            $product_img_cell_array = $product_img_cell_array.concat(r);
        });
    }),
    (getSelectedVariantValue = () => {
        var a = "";
        return (
            $(".swatch_alt_val").each(function () {
                var r = $(this);
                r.prop("checked") && ((r = r.val()), (a += r + "-"));
            }),
            (a = a.replace(/-\s*$/, ""))
        );
    }),
    (imageUpdater = (r) => {
        var t = getSelectedVariantValue(),
            a = 0;
      console.log(t);
      if ($('.shopify-product-form > div.display-70mai').length > 0) {
      $(".store-pickup-message").remove();
      var str2 = "with Installation";
      var swatchArr = t.split('-');
      console.log(swatchArr[0]);
      if(t.indexOf(str2) != -1){
          console.log(str2 + " found");
        $("[data-value='"+swatchArr[0]+"']").after( "<p class='store-pickup-message'>Select 'Store Pickup' on cart for installation at your nearest TRAPO hub, excluding TRAPO Mid Valley.</p>" );
      }
      }
      
      if ($('body.product-mat .swatch > div.option_title:contains("Packages")').length > 0) {
       // var radioValue = $("input[name='properties[Transmission]']:checked").val();
        var radioValue = "Automatic";
        var altArray = t.split('-');
        console.log(altArray);
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue)
        console.log(newAltArr);
        var altStr = newAltArr.toString();
        console.log(altStr);
        var t = altStr.replace(/,/g, '-');
		console.log(t); 
      }

      if ($('body.product-hex .swatch > div.option_title:contains("Packages")').length > 0) {
        var radioValue = "Automatic";
        var altArray = t.split('-');
        console.log(altArray);
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue)
        console.log(newAltArr);
        var altStr = newAltArr.toString();
        console.log(altStr);
        var t = altStr.replace(/,/g, '-');
		console.log(t); 
      }

      if ($('body.product-eco .swatch > div.option_title:contains("Packages")').length > 0) {
        var radioValue = "Automatic";
        var altArray = t.split('-');
        console.log(altArray);
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue)
        console.log(newAltArr);
        var altStr = newAltArr.toString();
        console.log(altStr);
        var t = altStr.replace(/,/g, '-');
		console.log(t); 
      }
      
      
      if(t == "Black-Automatic-Red"  || t == "Black-Automatic-Black"){
        $(".express-shipping").show();
        $(".standard-shipping").hide();
        
      }else{
        $(".express-shipping").hide();
        $(".standard-shipping").show();
      }
        $product_img_cell.each(function () {
            $(this).remove();
            for (var r = 0; r < $product_img_cell_array.length; r++) {
                var a = $product_img_cell_array[r].attr("data-variant_img_alt");
                (t != a && "main_image" != a) || $("#productImg .flickity-slider").append($product_img_cell_array[r]);
            }
        }),
            (a = r ? 1 : 0),
            $product_slider.flickity("destroy"),
            $("#productImg").flickity({ pageDots: !0, initialIndex: a });
    }),
    (priceUpdate = (r) => {
        var t = getSelectedVariantValue(),
            a = 0;
      console.log(t);
      if ($('.shopify-product-form > div.display-70mai').length > 0) {
      $(".store-pickup-message").remove();
      var str2 = "with Installation";
      var swatchArr = t.split('-');
      console.log(swatchArr[0]);
      if(t.indexOf(str2) != -1){
          console.log(str2 + " found");
        $("[data-value='"+swatchArr[0]+"']").after( "<p class='store-pickup-message'>Select 'Store Pickup' on cart for installation at your nearest TRAPO hub, excluding TRAPO Mid Valley.</p>" );
      }
      }
      
      if ($('body.product-mat .swatch > div.option_title:contains("Packages")').length > 0) {
       // var radioValue = $("input[name='properties[Transmission]']:checked").val();
        var radioValue = "Automatic";
        var altArray = t.split('-');
        console.log(altArray);
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue)
        console.log(newAltArr);
        var altStr = newAltArr.toString();
        console.log(altStr);
        var t = altStr.replace(/,/g, '-');
		console.log(t); 
      }

      if ($('body.product-hex .swatch > div.option_title:contains("Packages")').length > 0) {
        var radioValue = "Automatic";
        var altArray = t.split('-');
        console.log(altArray);
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue)
        console.log(newAltArr);
        var altStr = newAltArr.toString();
        console.log(altStr);
        var t = altStr.replace(/,/g, '-');
		console.log(t); 
      }

      if ($('body.product-eco .swatch > div.option_title:contains("Packages")').length > 0) {
        var radioValue = "Automatic";
        var altArray = t.split('-');
        console.log(altArray);
        var newAltArr = altArray.slice(0, -1); 
        newAltArr.splice(1, 0, radioValue)
        console.log(newAltArr);
        var altStr = newAltArr.toString();
        console.log(altStr);
        var t = altStr.replace(/,/g, '-');
		console.log(t); 
      }
      
      
      if(t == "Black-Automatic-Red"  || t == "Black-Automatic-Black"){
        $(".express-shipping").show();
        $(".standard-shipping").hide();
        
      }else{
        $(".express-shipping").hide();
        $(".standard-shipping").show();
      }
        $product_img_cell.each(function () {
            $(this).remove();
            for (var r = 0; r < $product_img_cell_array.length; r++) {
                var a = $product_img_cell_array[r].attr("data-variant_img_alt");
                (t != a && "main_image" != a) || $("#productImg .flickity-slider").append($product_img_cell_array[r]);
            }
        }),
            (a = r ? 1 : 0), 
            $product_slider.flickity("destroy"),
            $("#productImg").flickity({ pageDots: !0, initialIndex: a });
    }),
    (changeSwatch = (r) => {
      $(r);
      var mainPrice = $(r).data("mainprice");
      var mainDisPrice =$(r).data("price");
      
       $(".omega .current_price.discounted_money").removeData('sprice');
      $(".omega .current_price.discounted_money").removeData('price');
      $(".omega .current_price.discounted_money").removeData('mainprice');
      
      $(".omega .current_price.discounted_money").attr("data-sprice",mainPrice);
      $(".omega .current_price.discounted_money").attr("data-price",mainDisPrice);
      $(".omega .current_price.discounted_money").attr("data-mainprice",mainDisPrice);
      
      if ($('input[name="trapo_fix"]').is(':checked')) {
       
         var trapoFixPrice = $('input[name="trapo_fix"]:checked').data("price");
         var trapoFixDisPrice = $('input[name="trapo_fix"]:checked').data("disprice");
        
        var totalMainPrice = mainPrice + trapoFixPrice;
        var totalMainDisPrice = mainDisPrice + trapoFixDisPrice;
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
          var totalMainPriceFormat = Shopify.formatMoney(totalMainPrice, $("body").data("money-format"));
           var totalDisPriceFormat = Shopify.formatMoney(totalMainDisPrice, $("body").data("money-format"));
          $(".current_price.discounted_money .money").text(totalMainPriceFormat);
          $(".customise_money .money").text(totalDisPriceFormat);
      }
      else if ($('input[name="trapo_hex"]').is(':checked')) {
        var trapoHexPrice = $('input[name="trapo_hex"]:checked').data("discounted");
         var trapoHexDisPrice = $('input[name="trapo_hex"]:checked').data("price");
        
        var totalMainPrice = mainPrice + trapoHexPrice;
        var totalMainDisPrice = mainDisPrice + trapoHexDisPrice;
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
          var totalMainPriceFormat = Shopify.formatMoney(totalMainPrice, $("body").data("money-format"));
           var totalDisPriceFormat = Shopify.formatMoney(totalMainDisPrice, $("body").data("money-format"));
          $(".current_price.discounted_money .money").text(totalMainPriceFormat);
          $(".customise_money .money").text(totalDisPriceFormat); 
      }
      else if ($('input[name="trapo_eco"]').is(':checked')) {
        var trapoEcoPrice = $('input[name="trapo_eco"]:checked').data("discounted");
         var trapoEcoDisPrice = $('input[name="trapo_eco"]:checked').data("price");
        
        var totalMainPrice = mainPrice + trapoEcoPrice;
        var totalMainDisPrice = mainDisPrice + trapoEcoDisPrice;
        console.log(totalMainPrice);
        console.log(totalMainDisPrice);
        
          var totalMainPriceFormat = Shopify.formatMoney(totalMainPrice, $("body").data("money-format"));
           var totalDisPriceFormat = Shopify.formatMoney(totalMainDisPrice, $("body").data("money-format"));
          $(".current_price.discounted_money .money").text(totalMainPriceFormat);
          $(".customise_money .money").text(totalDisPriceFormat);
      }else{
        var variantPrice = $(r).data("price");
         var variantmainPrice = $(r).data("mainprice");
        var totalPriceFormat = Shopify.formatMoney(variantPrice, $("body").data("money-format"));
        var totalMainPriceFormat = Shopify.formatMoney(variantmainPrice, $("body").data("money-format"));
        $(".customise_money .money").text(totalPriceFormat);
        $(".current_price.discounted_money .money").text(totalMainPriceFormat);
      }
      //$('input[name="trapo_fix"]').not(this).prop("checked", false);
     // $('input[name="trapo_hex"]').not(this).prop("checked", false);
     // $('input[name="trapo_eco"]').not(this).prop("checked", false);
      console.log(variantPrice);
        setTimeout(function () {
            imageUpdater(!0);
        }, 500);
    });
